import { render } from "./BillingSupplierDialog.vue?vue&type=template&id=40ba1ab7&ts=true"
import script from "./BillingSupplierDialog.vue?vue&type=script&lang=ts"
export * from "./BillingSupplierDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__